import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, USER_TOKEN_KEY } from "@/lib/api";

const PersonnelContext = createContext({
  user: null,
  loading: true,
  refresh: async () => {},
  signOut: () => {},
});

export function PersonnelProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem(USER_TOKEN_KEY);
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/personnel/me");
      setUser(data);
    } catch {
      localStorage.removeItem(USER_TOKEN_KEY);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem(USER_TOKEN_KEY);
    setUser(null);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <PersonnelContext.Provider value={{ user, loading, refresh, signOut }}>
      {children}
    </PersonnelContext.Provider>
  );
}

export function usePersonnel() {
  return useContext(PersonnelContext);
}
